/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_S1Inputs */

const en_lg_guest_s1 = /** @type {(inputs: Lg_Guest_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As an authorized host, open **Guests** in your meeting or the area you are visiting. Set the link use limit (1–5), create it, then share it yourself with the intended visitors. The link lasts 24 hours.`)
};

const id_lg_guest_s1 = /** @type {(inputs: Lg_Guest_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebagai host yang berizin, buka **Tamu** pada rapatmu atau area yang sedang kamu kunjungi. Atur batas pemakaian tautan (1–5), buat tautan, lalu bagikan sendiri kepada orang yang dituju. Tautan berlaku 24 jam.`)
};

/**
* | output |
* | --- |
* | "As an authorized host, open **Guests** in your meeting or the area you are visiting. Set the link use limit (1–5), create it, then share it yourself with the..." |
*
* @param {Lg_Guest_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_s1 = /** @type {((inputs?: Lg_Guest_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_s1(inputs)
	return en_lg_guest_s1(inputs)
});